import { CoverRequest } from '../../../../models/coverings/CoverRequest';
import {
    GetSchedulingByEmployeeAndDateRequest,
    SchedulingByEmployeeAndDateModel,
} from '../../../../models/coverings/workshiftSchedulingCover';
import { requests } from '../apiAgent';

export const CoveringsAPI = {
    getPendingRequestByAuthorizer: () => {
        return requests
            .get(
                '/jerusalem/api/v2.0.0/scheduling-cover-requests/pending-cover-requests-by-authorizer'
            )
            .then((response) => response);
    },
    getPendingCoversByUserRequest: () => {
        return requests
            .get(
                '/jerusalem/api/v2.0.0/scheduling-cover-requests/get-cover-requests-by-requesting-user'
            )
            .then((response) => response);
    },
    getPendingCoversByUserCovering: () => {
        return requests
            .get(
                '/jerusalem/api/v2.0.0/scheduling-cover-requests/get-coverage-requests-by-user-covering'
            )
            .then((response) => response);
    },
    create: (model: CoverRequest) => {
        return requests
            .post('/jerusalem/api/v2.0.0/scheduling-cover-requests', model)
            .then((response) => response);
    },
    getSchedulingByEmplooye: (model: { employeeId: number; date: string }) => {
        return requests
            .post(
                '/jerusalem/api/v2.0.0/scheduling-cover-requests/get-scheduling-by-employee-and-date',
                model
            )
            .then((response) => response);
    },
    acceptCoverByUserEmployee: (id: number, comments: string) => {
        return requests
            .put(
                '/jerusalem/api/v2.0.0/scheduling-cover-requests/' +
                    id +
                    '/accept-cover-request',
                { comments: comments }
            )
            .then((response) => response);
    },
    approveCover: (id: number, comments: string) => {
        return requests
            .put(
                '/jerusalem/api/v2.0.0/scheduling-cover-requests/' +
                    id +
                    '/approve-cover-request',
                { comments: comments }
            )
            .then((response) => response);
    },
    noAcceptCoverByUserEmployee: (id: number, comments: string) => {
        return requests
            .put(
                '/jerusalem/api/v2.0.0/scheduling-cover-requests/' +
                    id +
                    '/reject-cover-request',
                { comments: comments }
            )
            .then((response) => response);
    },
    rejectCoverBy: (id: number, comments: string) => {
        return requests
            .put(
                '/jerusalem/api/v2.0.0/scheduling-cover-requests/' +
                    id +
                    '/reject-cover-request-by-authorizer',
                { comments: comments }
            )
            .then((response) => response);
    },
    getEmployeeCover: (documentNumber: string) => {
        return requests
            .get(
                `/jerusalem/api/v2.0.0/scheduling-cover-requests/${documentNumber}/get-cover-person-by-document-number-or-card-number`
            )
            .then((response) => response);
    },
    getWorkshiftShcedulingByEmployee: (
        body: GetSchedulingByEmployeeAndDateRequest
    ) => {
        return requests
            .post(
                `/jerusalem/api/v2.0.0/scheduling-cover-requests/get-scheduling-by-employee-and-date`,
                body
            )
            .then((response) => response);
    },
};
